import { useTranslation } from 'react-i18next';
import Gallery from '../files/Gallery';
import { useNavigate, useLocation } from 'react-router-dom';
import { FileObject } from 'react-mui-dropzone';
import { useEffect } from 'react';
import { Icons } from '../common/ui-component';
import { uploadLicensePhotoHash } from './constants';
import { Page } from './ui';
import * as amplitude from '@amplitude/analytics-browser';

type Props = {
  licensePhoto: FileObject | undefined;
  handleDeleteLicensePhoto: () => void;
  handleConfirmClick: () => void;
  hasLicense: boolean;
};

const ReviewLicensePhoto = ({ handleDeleteLicensePhoto, licensePhoto, handleConfirmClick, hasLicense }: Props) => {
  const { t } = useTranslation('photosPage');
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!licensePhoto && !hasLicense) {
      navigate(`${pathname}${search}${uploadLicensePhotoHash}`);
    }
    amplitude.track('photo_flow_id_confirm');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTryAgainClick = () => {
    handleDeleteLicensePhoto();
    navigate(`${pathname}${search}${uploadLicensePhotoHash}`);
  };

  return (
    <Page>
      <Page.Title>{t('confirmPhotoId')}</Page.Title>
      <Page.UploadBox>
        <Page.UploadBox.Image>
          <Gallery photos={licensePhoto ? [licensePhoto] : []} singleFileMode={true} />
        </Page.UploadBox.Image>
        <Page.UploadBox.Container>
          <Page.UploadBox.Container.Title>{t('idPhotoChecklist')}</Page.UploadBox.Container.Title>
          <Page.UploadBox.Container.List>
            <Page.UploadBox.Container.List.Item>
              <Icons.Checkmark /> {t('clearlyShowsPhotoAndText')}
            </Page.UploadBox.Container.List.Item>
            <Page.UploadBox.Container.List.Item>
              <Icons.Checkmark /> {t('isNotEditedFilteredBlurryOrDark')}
            </Page.UploadBox.Container.List.Item>
            <Page.UploadBox.Container.List.Item>
              <Icons.Checkmark /> {t('showsTheEntireFrontOfYourId')}
            </Page.UploadBox.Container.List.Item>
          </Page.UploadBox.Container.List>
          <Page.UploadBox.Container.Action>
            <Page.Button onClick={() => handleConfirmClick()}>
              <Page.Button.Secondary>{t('confirm').toUpperCase()}</Page.Button.Secondary>
            </Page.Button>
            <Page.Button onClick={() => handleTryAgainClick()}>
              <Page.Button.Custom
                className="tw-border tw-border-solid tw-border-black
               tw-bg-white tw-text-black tw-hover:tw-text-black"
              >
                {t('tryAgain').toUpperCase()}
              </Page.Button.Custom>
            </Page.Button>
          </Page.UploadBox.Container.Action>
        </Page.UploadBox.Container>
      </Page.UploadBox>
    </Page>
  );
};

export default ReviewLicensePhoto;
